import { transport } from 'config/transport';

export function callApiExportAbsencesSummary(yearMonth) {
    return transport.get(`/mamnon/absences/summary-report`, { params: { yearMonth }, responseType: 'blob' });
}
